const permissions = [
  {value: 'pos', text: 'POS'},
  {value: 'inv', text: 'Inventory'},
  {value: 'inv:admin', text: 'Admin', requirePermission: 'admin'},
  {value: 'inv:reports', text: 'Reports'},
];
permissions.findByValue = (value) => {
  return permissions.find(x => x.value === value);
};

export default permissions;



// WEBPACK FOOTER //
// ./src/User/permissions.js